import { override } from 'environment-override';
import featureFlagsFactory from 'shared/featureFlags/factory';

const featureFlags = featureFlagsFactory(override);

export default featureFlags;
